import React from 'react';
import PropTypes from 'prop-types';
import memoizeOne from 'memoize-one';
import moment from 'moment';
import OverviewTable from '../../../components/Table/TicketOverviewTable';
import localization from '../../../i18n/localization';
import CancelOrderButton from './CancelOrderButton';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import allTicketStrategy from './ticketStrategy';

class CancelTicketAction extends React.Component {
  successNotificationHandler(text) {
    return () => {
      this.props.addNotification('success', text);
      this.setState({ loading: false });
    };
  }
  failureNotificationHandler(text) {
    return () => {
      this.props.addNotification('danger', text);
      this.setState({ loading: false });
    };
  }

  render() {
    const {
      ticketId,
      visible,
      onCancelTickets,
      canceling,
      role,
      isOnlyVoucher,
    } = this.props;
    return visible ? (
      <CancelOrderButton
        loading={canceling}
        buttonSize={'sm'}
        onCancelOrder={(sendConfirmationMail, refundVoucher) =>
          onCancelTickets([ticketId], sendConfirmationMail, refundVoucher)
        }
        role={role}
        isOnlyVoucher={isOnlyVoucher}
      />
    ) : null;
  }
}

CancelTicketAction = withSnackbar(CancelTicketAction);

const columnDefinition = [
  { id: 'id', label: 'ID' },
  { id: 'type', label: 'Typ' },
  { id: 'info', label: 'Info' },
  { id: 'totalPrice', label: 'Total (CHF)' },
  { id: 'action', label: '' },
];

function getDiscountPercentage(strategy) {
  switch (strategy) {
    case allTicketStrategy.PREORDER:
    case allTicketStrategy.PREORDER_FREE_KIDS_SATURDAY:
      return localization.de.PERCENTAGE5;
    case allTicketStrategy.PRESALE:
    case allTicketStrategy.PRESALE_FREE_KIDS_SATURDAY:
      return localization.de.PERCENTAGE20;
    default:
      return '';
  }
}

const transform = memoizeOne(
  (
    orderId,
    tickets,
    cancelable,
    onCancelTickets,
    canceling,
    role,
    isOnlyVoucher
  ) =>
    tickets.map(ticket => {
      const addonPrice = ticket.addons.reduce(
        (total, addon) => total + addon.price,
        0
      );
      const totalFees = ticket.fees.reduce(
        (total, fee) => total + fee.amount,
        0
      );
      return {
        id: ticket.id,
        type:
          localization.de[ticket.ticketType] +
          ' ' +
          getDiscountPercentage(ticket.pricingStrategy),
        issuedTo: ticket.issuedTo,
        validFrom: moment(ticket.validFrom).format('D.M.YYYY'),
        validTo: moment(ticket.validTo).format('D.M.YYYY'),
        skidays: localization.de[ticket.skidays],
        ageGroup: localization.de[ticket.personType],
        keycard: ticket.keycard.number,
        salesState: ticket.salesState,
        permissionState: ticket.permissionState,
        permissionSerialNumber: ticket.permissionSerialNumber,
        barcodeSerialNumber: ticket.barcode
          ? ticket.barcode.permissionSerialNumber
          : undefined,
        barcodeImage: ticket.barcode ? ticket.barcode.image : undefined,
        addons: ticket.addons
          .map(addon => localization.de[addon.addonType])
          .join(','),
        fees: ticket.fees.map(fee => localization.de[fee.type]).join(','),
        ticketPrice: (ticket.price / 100).toFixed(2),
        addonPrice: (addonPrice / 100).toFixed(2),
        totalFees: (totalFees / 100).toFixed(2),
        totalPrice: ((ticket.price + addonPrice + totalFees) / 100).toFixed(2),
        confirmationNumber: ticket.orderDetails
          ? ticket.orderDetails.confirmationNumber
          : '',
        pricingStrategy:
          localization.de.pricingStrategy[ticket.pricingStrategy],
        htagadiscount: ticket.htagadiscount,
        action: (
          <CancelTicketAction
            canceling={canceling}
            visible={
              cancelable &&
              ticket.permissionState !== 'CONSUMED' &&
              (ticket.salesState === 'BOOKED_AND_TRANSFERRED' ||
                ticket.salesState === 'BOOKED' ||
                ticket.salesState === 'BOOKED_AND_REJECTED' ||
                ticket.salesState === 'RESERVED')
            }
            orderId={orderId}
            ticketId={ticket.id}
            onCancelTickets={onCancelTickets}
            role={role}
            isOnlyVoucher={isOnlyVoucher}
          />
        ),
        refundWithoutPayment: ticket.refundWithoutPayment,
      };
    })
);

function SkidataTicketTable({
  orderId,
  tickets,
  cancelable,
  onCancelTickets,
  canceling,
  role,
  isOnlyVoucher,
}) {
  return (
    <OverviewTable
      columnDefinition={columnDefinition}
      data={transform(
        orderId,
        tickets,
        cancelable,
        onCancelTickets,
        canceling,
        role,
        isOnlyVoucher
      )}
      hover={false}
    />
  );
}

SkidataTicketTable.propTypes = {
  tickets: PropTypes.array,
};

export default SkidataTicketTable;



// WEBPACK FOOTER //
// ./src/views/skidata/components/SkidataTicketTable.jsx